import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, SectionTitle } from '../Section';
import { ImageSlot } from '../ImageSlot';
import { IMAGES, offerItems } from '../../data/landing';
export function OfferSection() {
  return <Section tone="ink" wide data-id="element-80" data-mp="fgbjx09chi8l">
      <div className="grid gap-8 md:grid-cols-2 md:items-center md:gap-12" data-id="element-81" data-mp="fjpmo9lx7tgk">
        <ImageSlot name="Kit del curso INOLVIDABLE con Beatriz Espina" aspect="aspect-[3/2]" src={IMAGES.mockup} data-id="element-82" data-mp="aijt69kfs25z" />
        <div data-id="element-83" data-mp="6j173agvpl1k">
          <SectionTitle data-id="element-84" data-mp="1qhuogtxgvyc">Todo lo que te llevas</SectionTitle>
          <ul className="mt-7 space-y-3.5" data-id="element-85" data-mp="1ox1ovn9hl2l">
            {offerItems.map(item => <li key={item} className="flex gap-3.5 text-[17px] leading-relaxed text-ivory" data-id="element-86" data-mp="3sxkn1bli58a5">
                <CheckIcon aria-hidden="true" strokeWidth={2} className="mt-1 h-5 w-5 shrink-0 text-gold" data-id="element-87" data-mp="3nz0x703sfcci" />
                <span data-id="element-88" data-mp="3iy3gyt2c8sdn">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}